const initialExtraSlideListState = {
  fetching: false,
  fetched: false,
  extraSlides: [],
  error: null,
  saving: false,
  saved: false,
  deleted: false,
  deleting: false,
  pageSize: 9,
  paginationPage: 1,
  nbResult: 0,
  filter: {
    visibility: "-1",
    searchTitle: "",
    category: []
  },
  categorySettings: {
    categoryList: [],
    saving: false,
    saved: false,
    fetching: false,
    fetched: false,
    error: null
  }
};

export const extraSlideListReducer = (
  state = initialExtraSlideListState,
  action
) => {
  switch (action.type) {
    case "FETCH_EXTRA_SLIDE_LIST_PENDING": {
      return { ...state, fetched: false, fetching: true };
    }
    case "FETCH_EXTRA_SLIDE_LIST_FULFILLED": {
      const { data, nbResult } = action.payload.data;
      return {
        ...state,
        fetching: false,
        fetched: true,
        error: null,
        extraSlides: data || [],
        nbResult: nbResult
      };
    }
    case "FETCH_EXTRA_SLIDE_LIST_REJECTED": {
      let error = action.payload;
      if (!error.response) {
        error = {
          title: error,
          code: 500
        };
      } else {
        switch (error.response.status) {
          case 404:
            error = {
              title: error.response.data.title,
              code: 404
            };
            break;
          default:
        }
      }
      return {
        ...state,
        fetching: false,
        extraSlides: [],
        nbResult: 0,
        error
      };
    }

    case `SAVE_EXTRA_SLIDE_PENDING`: {
      return { ...state, saved: false, saving: true };
    }
    case `SAVE_EXTRA_SLIDE_FULFILLED`: {
      return {
        ...state,
        saving: false,
        saved: true
      };
    }
    case `SAVE_EXTRA_SLIDE_REJECTED`: {
      let error = action.payload;
      switch (error.response.status) {
        case 500:
          error = {
            title: error.response.data.title,
            code: 500
          };
          break;
        default:
      }
      return {
        ...state,
        saved: false,
        error
      };
    }
    case `DELETE_EXTRA_SLIDE_PENDING`: {
      return { ...state, deleted: false, deleting: true };
    }
    case `DELETE_EXTRA_SLIDE_FULFILLED`: {
      return { ...state, deleted: true, deleting: false };
    }
    case `DELETE_EXTRA_SLIDE_REJECTED`: {
      let error = action.payload;
      switch (error.response.status) {
        case 500:
          error = {
            title: error.response.data.title,
            code: 500
          };
          break;
        default:
      }
      return {
        ...state,
        deleted: false,
        deleting: false,
        error
      };
    }
    case "SET_EXTRA_SLIDES_LIST_PAGINATION_PAGE": {
      return { ...state, paginationPage: action.pageNumber };
    }
    case "SET_VISIBILITY_EXTRA_SLIDE": {
      return {
        ...state,
        filter: { ...state.filter, visibility: action.selected }
      };
    }

    case "SET_SEARCH_TITLE_EXTRA_SLIDE": {
      return {
        ...state,
        filter: { ...state.filter, searchTitle: action.title }
      };
    }

    case "SET_EXTRA_SLIDE_LIST": {
      return {
        ...state,
        extraSlides: action.extraSlides
      };
    }

    case "SET_CATEGORY_SELECTED_ITEM": {
      return {
        ...state,
        filter: { ...state.filter, category: action.newSelectedItems }
      };
    }

    case "FETCH_CATEGORY_EXTRA_SLIDE_LIST_PENDING": {
      return {
        ...state,
        categorySettings: {
          ...state.categorySettings,
          fetched: false,
          fetching: true
        }
      };
    }
    case "FETCH_CATEGORY_EXTRA_SLIDE_LIST_FULFILLED": {
      const { data } = action.payload.data;
      return {
        ...state,
        categorySettings: {
          ...state.categorySettings,
          fetching: false,
          fetched: true,
          error: null,
          categoryList: data || []
        }
      };
    }
    case "FETCH_CATEGORY_EXTRA_SLIDE_LIST_REJECTED": {
      let error = action.payload;
      if (!error.response) {
        error = {
          title: error,
          code: 500
        };
      } else {
        switch (error.response.status) {
          case 404:
            error = {
              title: error.response.data.title,
              code: 404
            };
            break;
          default:
        }
      }
      return {
        ...state,
        categorySettings: {
          ...state.categorySettings,
          fetching: false,
          error,
          categoryList: []
        }
      };
    }

    case `SAVE_CATEGORY_EXTRA_SLIDE_PENDING`: {
      return {
        ...state,
        categorySettings: {
          ...state.categorySettings,
          saved: false,
          saving: true
        }
      };
    }
    case `SAVE_CATEGORY_EXTRA_SLIDE_FULFILLED`: {
      return {
        ...state,
        categorySettings: {
          ...state.categorySettings,
          saved: true,
          saving: false
        }
      };
    }
    case `SAVE_CATEGORY_EXTRA_SLIDE_REJECTED`: {
      let error = action.payload;
      switch (error.response.status) {
        case 500:
          error = {
            title: error.response.data.title,
            code: 500
          };
          break;
        default:
      }
      return {
        ...state,
        saved: false,
        error
      };
    }

    case `DELETE_CATEGORY_EXTRA_SLIDE_PENDING`: {
      return {
        ...state,
        categorySettings: {
          ...state.categorySettings,
          deleted: false,
          deleting: true
        }
      };
    }
    case `DELETE_CATEGORY_EXTRA_SLIDE_FULFILLED`: {
      return {
        ...state,
        categorySettings: {
          ...state.categorySettings,
          deleted: true,
          deleting: false
        }
      };
    }
    case `DELETE_CATEGORY_EXTRA_SLIDE_REJECTED`: {
      let error = action.payload;
      switch (error.response.status) {
        case 500:
          error = {
            title: error.response.data.title,
            code: 500
          };
          break;
        default:
      }
      return {
        ...state,
        deleted: false,
        deleting: false,
        error
      };
    }

    case "SET_CATEGORY_EXTRA_SLIDE_LIST": {
      return {
        ...state,
        categorySettings: {
          ...state.categorySettings,
          categoryList: action.categoryList
        }
      };
    }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/extraSlideList.js